import { connect } from 'react-redux'
import ImiView from '../../../components/Sections/Imi'
import { loadImis, saveInform, loadImisByPagination } from '../../../actions/imi';

const mapStateToProps = (state, ownProps) => {
  return {
  	list: state.imi.list,
  	current_page: state.imi.current_page,
  	last_page: state.imi.last_page,
  	total: state.imi.total,
    loading: state.imi.loading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 		loadImis: (pl, p) => dispatch(loadImis(pl, p)), 
 		saveInform: item => dispatch(saveInform(item)),
    loadImisByPagination: (pl, p) => dispatch(loadImisByPagination(pl, p)),
 		//loadClients: value => dispatch(loadClients())
  }
}

const Imi = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImiView)

export default Imi


// WEBPACK FOOTER //
// ./src/containers/Sections/Imi/index.js